var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-7"},[_c('div',{staticClass:"heading mb-7"},[_vm._v("Заказ №"+_vm._s(_vm.id)+" успешно оплачен")])])
}
var staticRenderFns = []

export { render, staticRenderFns }